import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchPDAs } from '../actions/pdas'

import PDAList from '../components/PDAList'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import "../styles/PDAsAdminView.css"

class PDAsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }

  }

  componentDidMount() {
    this.props.fetchPDAs()
  }

  render() {
    const { role, type, pdas, error } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!pdas) {
      return <LoadingProgress />
    }

    return (
      <div className="pdas-admin-view">

        <div className="pdas-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-mobile-alt mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">PDAs</span>
              </h1>
            </div>

            {role === 'ADMIN' && type === 'MASTER' && (
              <div className="header-actions">
                <Link to="/pdas/add" className="pdas-admin-btn primary">
                  <i className="fas fa-plus"></i>
                  <span>Nueva</span>
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-12">
            <PDAList pdas={pdas} role={role} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  pdas: state.pdas.pdas,
  error: state.pdas.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchPDAs: bindActionCreators(fetchPDAs, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(PDAsView)
